
import Vue from 'vue';
import { mapGetters, mapActions, mapState } from 'vuex';
import mixins from 'vue-typed-mixins';

import { formatNumber } from '@/i18n';

import BannerStandImage from '@/store/modules/banner-stand-images/banner-stand-image';
import { BannerStandImageStatus } from '@/store/modules/banner-stand-images/banner-stand-image';
import { BannerStandImagesActions } from '@/store/modules/banner-stand-images/types';

import tableViewMixin from '@/components/mixins/table-view';
import NotificationBanner from '@/components/blocks/notification-banner.vue';
import TableListSkeleton from '@/components/skeletons/table-list.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';
import PaginationControl from '@/components/controls/pagination.vue';
import BannerStandImagesFilter from '@/components/forms/banner-stand-images-filter.vue';

export default mixins(tableViewMixin).extend({
  name: 'BannerStandImagesView',
  components: {
    NotificationBanner,
    TableListSkeleton,
    Dropdown,
    PaginationControl,
    BannerStandImagesFilter,
  },
  data() {
    return {
      BannerStandImageStatus,
    };
  },
  computed: {
    ...mapGetters('user/profile', ['isSuperAdmin', 'isAdmin']),
    ...mapState('bannerStandImages', {
      items: 'list',
      pagination: 'listPagination',
    }),
    ...mapState(['languages']),
    ...mapGetters('bannerStandImages', {
      isLoading: 'listIsLoading',
      isLoaded: 'listIsLoaded',
      isEmpty: 'listIsEmpty',
    }),
  },
  methods: {
    formatNumber,
    hasImages(item: BannerStandImage): boolean {
      return item.images && item.images.some((img: any) => img && img.thumbnail);
    },
    getLanguageName(code: string): string {
      const language = this.languages.find((lang: any) => lang.code === code);
      return language ? language.name : code.toUpperCase();
    },
    ...mapActions('bannerStandImages', {
      restoreAction: BannerStandImagesActions.RESTORE,
      removeItem: BannerStandImagesActions.DELETE,
    }),
    dropdownItems(item: BannerStandImage) {
      const items: DropdownItems = {
        edit: {
          label: this.$t('Edit'),
          icon: 'pencil',
        },
      };

      if (item.status === this.BannerStandImageStatus.Inactive) {
        items.restore = {
          label: this.$t('Restore'),
          icon: 'restore',
        };
      } else {
        items.delete = {
          label: this.$t('Delete'),
          icon: 'delete',
        };
      }

      return items;
    },
    handleClick(item: BannerStandImage, action: string) {
      if ('edit' === action) {
        this.$router.push({
          name: 'edit-banner-stand-image',
          params: { id: String(item.id) },
        });
      }

      if ('restore' === action) {
        const answer = window.confirm(this.$t('Do you really want to restore this banner stand image?'));

        if (answer) {
          this.restoreAction({ id: item.id });
        }
      }

      if ('delete' === action) {
        const answer = window.confirm(this.$t('Do you really want to delete this banner stand image?'));

        if (answer) {
          this.removeItem({ id: item.id });
        }
      }
    },
  },
});
